<template>
  <div class="block-benefits__wrapper">
    <bim-container class="block-benefits__container">
      <bimRow class="block-benefits d-flex flex-column">
        <bimCol>
          <bim-text class="block-benefits__title" type="h5" bold>Преимущества для Производителей:</bim-text>
        </bimCol>
        <bimRow class="benefits" justify="space-around">
          <bimCol cols=12 lg=6 class="benefits-item d-flex flex-column flex-sm-row pb-9 pb-lg-0 p-6 p-sm-0">
            <img src="/dist/assets/front_white/img/landing_gisp/img-landing-gisp-2.svg" alt="" class="benefits-item__image mr-11 pr-5 pb-6 pb-sm-0" />
            <div class="benefits-item__text-wrapper">
              <bim-text type="main" bold class="benefits-item__text-title">
                Статистика проектной потребности материалов или изделий напрямую от проектировщиков
              </bim-text>
              <bim-text type="medium" class="benefits-item__text-desc">
                Вы на 100% можете рассчитывать на индивидуальный подбор IT-решений ваших задач и проблем нами. Любая программа начинается с подробного ТЗ.
              </bim-text>
            </div>
          </bimCol>
          <bimCol cols=12 lg=6 class="benefits-item d-flex flex-column flex-sm-row p-6 p-sm-0">
            <img src="/dist/assets/front_white/img/landing_gisp/img-landing-gisp-3.svg" alt="" class="benefits-item__image mr-11 pb-6 pb-sm-0" />
            <div class="benefits-item__text-wrapper">
              <bim-text type="main" bold class="benefits-item__text-title">
                Обогащение свойств продукции, представленной в каталоге ГИСП
              </bim-text>
              <bim-text type="medium" class="benefits-item__text-desc">
                Цифровой каталог BIMLIB позволит упорядочить данные о продукции, свойствах, НТД и сертификатах в единую форму представления, выгружать их в табличной форме, обновлять информацию.
              </bim-text>
            </div>
          </bimCol>
        </bimRow>
      </bimRow>
    </bim-container>
  </div>
</template>

<script>
import bimContainer from "@bimlib/components/bimContainer";
import bimRow from "@bimlib/components/bimRow"
import bimCol from "@bimlib/components/bimCol"
export default {
  name: "BlockBenefitsForManufacturers",
  components: {
    bimContainer,
    bimRow,
    bimCol
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";
@import "./src/front_white/sass/components/grid-settings";

.block-benefits__wrapper {
  position: relative;
  z-index: 0;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $white-color-100;
    z-index: -1;
  }
}

.block-benefits {
  padding: 94px 0 120px;
  
  @media screen and (max-width: $breakpoint-sm) {
    padding: 30px 0 40px;
  }

  .block-benefits__title {
    text-align: center;
    line-height: 1.13;
    padding-bottom: 71px;
  }
}

.benefits {

  .benefits-item {
    max-width: 565px;
  }

  .benefits-item__text-title {
    padding-bottom: 14px;
    line-height: 1.44;
  }
  .benefits-item__text-desc {
    line-height: 1.57;
    letter-spacing: 0.2px;
  }
}
</style>
